import { useState } from "react"

export const Pagination = ({ itemsPerPage, totalItems, changePage, currentPage }) => {
    const pageNumbers = []
    for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
        pageNumbers.push(i)
    }
    const lastPage = pageNumbers.length

    const distance = lastPage / 2 + 2

    return (
        <nav aria-label="Page navigation example">
            <ul className="pagination mt-2">
                <li className="page-item prev-item" onClick={() => {
                    if (currentPage > 1) {
                        changePage(currentPage - 1)
                    }
                }}>
                    <a className="page-link" />
                </li>

                {pageNumbers.map(number => {
                    if (number == currentPage || number == currentPage + 1 || number == currentPage - 1 || number == lastPage - 1 || number == lastPage) {
                        return (
                            <li key={number} className={"page-item " + (currentPage == number && "active")} onClick={e => {
                                changePage(number)
                            }}>
                                <a className="page-link" >
                                    {number}
                                </a>
                            </li>
                        )
                    }
                    if (number == distance) {
                        return (<li key={number} className="page-item dot" >
                            <a className="page-link">
                                ....
                            </a>
                        </li>)
                    }
                }
                )
                }
                <li className="page-item next-item" onClick={() => {
                    if (currentPage < lastPage) {
                        changePage(currentPage + 1)
                    }
                }}>
                    <a className="page-link" />
                </li>
            </ul>
        </nav>

    )
}